import { TtsContainer, TtsHeader } from './styles';
import { EditablePage } from '../../widgets/TTS/EditablePage';
import { CharacterCounter } from '../../widgets/TTS/EditablePage/CharacterCounter';
import { HelpPanel } from '../../widgets/HelpPanel';
import { useEffect, useState } from 'react';
import { MobileTts } from '../../widgets/TTS/MobileTts';
import { useStore } from '../../store';
import { useTranslation } from 'react-i18next';
import { TutorialPopover } from '../../widgets/TutorialPopover';
import { QuotaPopup } from '../../widgets/QuotaPopup';

interface TtsProps {
  isTrial: boolean;
  appId: string;
  firstRunEnabled?: boolean;
  tid: string;
  currentUser: string;
  isMobile?: boolean;
  isStandalone?: boolean;
}

export const NewTts = ({
  isTrial,
  appId,
  firstRunEnabled,
  tid,
  currentUser,
  isMobile,
  isStandalone,
}: TtsProps) => {
  const { projectInfo } = useStore();

  const [isPopoverVisible, setIsPopoverVisible] = useState(firstRunEnabled);

  const { t } = useTranslation('myapps');

  const [title, setTitle] = useState(t('TTS_TITLE'));
  const [subtitle, setSubtitle] = useState(t('TTS_SUBTITLE'));

  useEffect(() => {
    setTitle(projectInfo?.name ?? t('TTS_TITLE'));
    setSubtitle(projectInfo?.description ?? t('TTS_SUBTITLE'));
  }, [projectInfo, t]);

  return (
    <>
      {!isMobile ? (
        <TtsContainer>
          <TtsHeader>
            <div className="title">
              <h1 title={title}>{title}</h1>
              <h2 title={subtitle}>{subtitle}</h2>
            </div>
          </TtsHeader>
          <EditablePage isTrial={isTrial} />
          <CharacterCounter isTrial={isTrial} />
          <HelpPanel appId={appId} firstRunEnabled={firstRunEnabled} isStandalone={isStandalone} />

          <TutorialPopover
            appId={appId}
            scope="tts"
            dimissPopover={() => setIsPopoverVisible(false)}
            title="TTS App"
            isVisible={isPopoverVisible}
          />
          <QuotaPopup />
        </TtsContainer>
      ) : (
        <TtsContainer isMobile>
          <TtsHeader isMobile>
            <div className="title">
              <h1 title={title}>{title}</h1>
              <h2 title={subtitle}>{subtitle}</h2>
            </div>
          </TtsHeader>
          <MobileTts currentUser={currentUser} tid={tid} />
        </TtsContainer>
      )}
    </>
  );
};
